import { Injectable, inject } from "@angular/core";

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';

import { ContainerActions } from "@core/state/containers/containers.actions";
import { ContainersDataService } from "@core/services/datasources/containers-data.service";
import { createNormalizedError } from "@core/utilities/error-handler.util";


@Injectable({ providedIn: 'root' })
export class ContainersEffects {

  private readonly actions$ = inject(Actions);
  private readonly containersDataService = inject(ContainersDataService);

  constructor() { }

  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContainerActions.load),
      mergeMap(() => this.containersDataService.getAll()
        .pipe(
          map(containers => ContainerActions.loadSuccess({ containers })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ContainerActions.loadFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  add$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContainerActions.add),
      map((action) => action.command),
      mergeMap((command) => this.containersDataService.add(command)
        .pipe(
          map(container => ContainerActions.addSuccess({ container })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ContainerActions.addFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  update$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContainerActions.update),
      map((action) => action.command),
      mergeMap((command) => this.containersDataService.update(command)
        .pipe(
          map(container => ContainerActions.updateSuccess({ container })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ContainerActions.updateFailure({ error: normalizedError }));
          })
        )
      )
    )
  });

  remove$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContainerActions.remove),
      map((action) => action.id),
      mergeMap((id) => this.containersDataService.delete(id)
        .pipe(
          map(() => ContainerActions.removeSuccess({ id })),
          catchError(error => {
            const normalizedError = createNormalizedError(error);
            return of(ContainerActions.removeFailure({ error: normalizedError }));
          })
        )
      )
    )
  });
}
